import React from 'react';
import { Skeleton, useMediaQueryContext, useSlider } from '@fourthwall/components';
import { Pills } from '../components/Pills';
import { Slider } from '../components/Slider';
import { useHomeProducts } from '../useHomeProducts';
import * as S from './styled';
export const OnboardingProductsSlider = () => {
    const mediaQuery = useMediaQueryContext();
    const homeProducts = useHomeProducts();
    const slider = useSlider();
    if (!homeProducts || homeProducts?.isLoading) {
        return React.createElement(SkeletonComponent, null);
    }
    if (!homeProducts) {
        return null;
    }
    return (React.createElement(S.SliderContainer, { ...slider.getContainerProps() },
        homeProducts.categories && homeProducts.categories.visible && mediaQuery.tablet && (React.createElement(S.SliderHeader, null,
            React.createElement(Pills, null, homeProducts.categories.options.map((option) => {
                return (React.createElement(Pills.Pill, { key: option.value, active: option.value === homeProducts.categories.value, label: option.label, onClick: () => homeProducts?.categories.onChange(option.value) }));
            })))),
        React.createElement(Slider, { products: homeProducts.products, slider: slider, onProductClick: homeProducts.onProductClick, activeCategory: homeProducts.activeCategory })));
};
export const SkeletonComponent = () => {
    const mediaQuery = useMediaQueryContext();
    const skeletonCount = (() => {
        if (mediaQuery.tablet)
            return 5;
        return 2;
    })();
    return (React.createElement(S.SkeletonSlider, null, [...Array(skeletonCount)].map((_, index) => (React.createElement(S.SkeletonCard, { key: index },
        React.createElement(S.SkeletonProductImage, null),
        React.createElement(S.SkeletonProductInfo, null,
            React.createElement(Skeleton.Shape, { height: 20, width: "80%" }),
            React.createElement(Skeleton.Shape, { height: 16, width: "40%" })))))));
};
